import { type FilterItem } from 'widgets/FilterEditor/model'

export const LocalFilterTypes = new Set(['broadcast'])

export const isWidgetLocal = (filterItem: FilterItem) => {
  return LocalFilterTypes.has(filterItem.type)
}
